export const SlackIntegrationErrorCode = {
  TOKEN_REVOKED: 'TOKEN_REVOKED',
  DEFAULT: 'DEFAULT',
} as const

export type SlackIntegrationErrorCode =
  (typeof SlackIntegrationErrorCode)[keyof typeof SlackIntegrationErrorCode]
export class SlackIntegrationError extends Error {
  constructor(public readonly code: SlackIntegrationErrorCode) {
    super(code)
    this.name = 'SlackIntegrationError'
  }
}
